import { withInstall } from '@ll-plus/utils'

import BackTop from './src/back-top.vue'

export const LlBackTop = withInstall(BackTop)
export default LlBackTop
export * from './src/back-top'

declare module 'vue' {
  export interface GlobalComponents {
    LlBackTop: typeof BackTop
  }
}
